<div
  [ngClass]="
    variant === 'public'
      ? 'max-w-[1512px] mx-auto px-4 sm:px-8 lg:px-site-gutter-lg xl:px-site-gutter-xl'
      : ''
  ">
  <div
    class="footer-grid grid grid-cols-12 gap-x-4 gap-y-4 pb-16 pt-8 lg:gap-y-12 overflow-hidden"
    [style.margin-left]="wide ? '-20px' : '0'"
    [style.margin-right]="wide ? '-10px' : '0'">
    <div class="col-span-12 py-0 lg:col-span-3 flex items-center">
      <img
        alt="Logo"
        class="footer-logo h-14 w-auto block"
        [style.margin-left]="variant !== 'public' ? '-12px' : '6px'"
        src="assets/collab-logo.png" />
    </div>
    <div
      class="col-span-12 lg:col-span-7 flex flex-col lg:flex-row lg:items-center leading-loose font-bold lg:gap-16 pt-4 lg:pt-0 text-bn-dark-grey">
      <a class="hover:underline" target="_blank" [href]="baseUrl + '/team'">
        Über uns
      </a>
      <a class="hover:underline" target="_blank" [href]="baseUrl + '/kontakt'">
        Kontakt & Support
      </a>
    </div>
    <div class="col-span-12 lg:col-span-2 flex items-center pt-2 lg:pt-0">
      <div
        class="flex gap-6 text-lg lg:ml-auto footer-social"
        [style.margin-right]="variant === 'public' ? '10px' : '0'">
        <a href="https://www.linkedin.com/company/bildigsnetz/" target="_blank">
          <mat-icon svgIcon="custom_linkedin"></mat-icon>
        </a>
        <a
          href="https://instagram.com/bildigsnetz/?igshid=OGQ5ZDc2ODk2ZA=="
          target="_blank">
          <mat-icon svgIcon="custom_instagram"></mat-icon>
        </a>
      </div>
    </div>

    <div
      class="col-span-12 lg:col-span-3 text-bn-dark-grey text-sm flex-col lg:flex-row pt-8 lg:pt-0">
      <span
        class="footer-copyright"
        [style.margin-left]="variant === 'public' ? '18px' : '0'"
        >Mensch & Bildung GmbH © {{ year }}</span
      >
    </div>
    <div
      class="col-span-12 lg:col-span-9 flex gap-x-8 text-bn-dark-grey text-sm flex-col lg:flex-row gap-y-4 lg:gap-y-2">
      <a
        class="hover:underline"
        target="_blank"
        [href]="baseUrl + '/impressum'">
        Impressum
      </a>
      <a class="hover:underline" target="_blank" [href]="baseUrl + '/agb'"
        >AGB</a
      >
      <a
        class="hover:underline"
        target="_blank"
        [href]="baseUrl + '/datenschutz'">
        Datenschutzerklärung
      </a>
    </div>
  </div>
</div>
